import {
  SafeAreaView,
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Image,
  ScrollView,
  Dimensions,
  Animated,
} from "react-native";
import React, { useState, useRef } from "react";
import AppFonts from "../../../Constants/AppFonts";
import AppImages from "../../../Constants/AppImages";
import AppColors from "../../../Constants/AppColors";
// import MapView, { PROVIDER_GOOGLE } from "react-native-maps";
import StationTopTab from "./StationTopTab";
import SuggestedCar from "./SuggestedCar";
import Appstyles from "../../../Constants/AppStyles";

const { width, height } = Dimensions.get("window");

const MainParkingManagement = ({ navigation }) => {
  const [selectedBox, setSelectedBox] = useState(1);
  const [activeTab, setActiveTab] = useState(0);
  const scrollViewRef = useRef(null);
  const translateX = useRef(new Animated.Value(0)).current;

  const handleBoxPressbtn = (item) => {
    setSelectedBox(item);
  };

  const tabs = [
    { key: "stations", label: "Stations", component: StationTopTab },
    { key: "suggested", label: "Suggested Cars", component: SuggestedCar },
  ];

  const handleTabPress = (index) => {
    setActiveTab(index);

    // Animate indicator
    Animated.spring(translateX, {
      toValue: index * (width / tabs.length),
      useNativeDriver: true,
      tension: 100,
      friction: 12,
    }).start();

    // Scroll to tab content
    if (scrollViewRef.current) {
      scrollViewRef.current.scrollTo({
        x: width * index,
        animated: true,
      });
    }
  };

  const handleScroll = (event) => {
    const contentOffsetX = event.nativeEvent.contentOffset.x;
    const tabIndex = Math.round(contentOffsetX / width);
    if (tabIndex !== activeTab) {
      setActiveTab(tabIndex);
      Animated.spring(translateX, {
        toValue: tabIndex * (width / tabs.length),
        useNativeDriver: true,
      }).start();
    }
  };

  return (
    <SafeAreaView style={Appstyles.safe7}>
      <View style={Appstyles.HeaderMain}>
        <View style={Appstyles.HeaderSec}>
          <TouchableOpacity
            style={Appstyles.Arrowstyle}
            onPress={() => {
              if (typeof window !== "undefined" && window.history.length > 1) {
                window.history.back();
              } else {
                window.location.href = "/";
              }
            }}
          >
            <Image
              source={AppImages.Backbtn}
              style={Appstyles.ArrowImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <Text style={Appstyles.HeaderText}>Parking Management</Text>
        </View>
        <View style={Appstyles.rc}>
          <TouchableOpacity onPress={() => navigation.navigate("/Dashboard/DashboardMap/Alerts/View")}>
            <Image
              source={AppImages.Bellnoti}
              style={Appstyles.BellImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
          <TouchableOpacity onPress={() => navigation.navigate("ParkManage")}>
            <Image
              source={AppImages.Plus}
              style={Appstyles.PlusImage}
              resizeMode="contain"
            />
          </TouchableOpacity>
        </View>
      </View>
      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        showsVerticalScrollIndicator={false}
      >
        <View style={{ backgroundColor: AppColors.sandal, flex: 1 }}>
          <View style={{ backgroundColor: AppColors.white, flex: 1 }}>
            <View style={styles.hjhah}>
              <View style={styles.mam}>
                <View style={styles.hjnshj}></View>
                {/* <MapView
                  style={styles.fleee}
                  provider={PROVIDER_GOOGLE}
                  showsUserLocation
                  initialRegion={{
                    latitude: 37.78825,
                    longitude: -122.4324,
                    latitudeDelta: 0.0922,
                    longitudeDelta: 0.0421,
                  }}
                ></MapView> */}
              </View>
            </View>

            {/* Custom Tab Bar */}
            <View style={styles.tabBarContainer}>
              <View style={styles.tabBar}>
                {tabs.map((tab, index) => (
                  <TouchableOpacity
                    key={tab.key}
                    style={styles.tabButton}
                    onPress={() => handleTabPress(index)}
                    activeOpacity={0.7}
                  >
                    <Text
                      style={[
                        styles.tabLabel,
                        activeTab === index && styles.activeTabLabel,
                      ]}
                    >
                      {tab.label}
                    </Text>
                  </TouchableOpacity>
                ))}

                {/* Animated Indicator */}
                <Animated.View
                  style={[
                    styles.indicator,
                    {
                      transform: [{ translateX }],
                      width: width / tabs.length,
                    },
                  ]}
                />
              </View>
            </View>

            {/* Tab Content with Horizontal Scroll */}
            <View style={{ flex: 1 }}>
              <ScrollView
                ref={scrollViewRef}
                horizontal
                pagingEnabled
                showsHorizontalScrollIndicator={false}
                onScroll={handleScroll}
                scrollEventThrottle={16}
                style={styles.contentContainer}
              >
                {tabs.map((tab, index) => (
                  <View key={tab.key} style={{ width, flex: 1 }}>
                    <ScrollView
                      showsVerticalScrollIndicator={false}
                      style={{ flex: 1 }}
                      contentContainerStyle={{ flexGrow: 1 }}
                    >
                      <tab.component />
                    </ScrollView>
                  </View>
                ))}
              </ScrollView>
            </View>
          </View>
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

export default MainParkingManagement;

const styles = StyleSheet.create({
  LoginWithOtpVw: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    padding: 8,
    width: "100%",
  },
  RegisterTxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  RegisterNxt: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 14,
    letterSpacing: 0.56,
  },
  LoginWithOtpV: {
    borderColor: "#9C4900",
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
    borderRadius: 10,
    width: "100%",
    height: 40,
  },
  sty: {
    flexDirection: "row",
    marginVertical: 20,
  },
  hjhah: {
    height: height * 0.4,
  },
  mam: {
    flex: 1,
    position: "relative",
  },
  hjnshj: {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "flex-end",
    paddingRight: 15,
    position: "absolute",
    bottom: 15,
    left: 0,
    right: 0,
    zIndex: 1,
  },
  fleee: { flex: 1 },

  // Custom Tab Styles
  tabBarContainer: {
    backgroundColor: AppColors.white,
    shadowColor: "#000",
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    elevation: 2,
  },
  tabBar: {
    flexDirection: "row",
    position: "relative",
    backgroundColor: AppColors.white,
  },
  tabButton: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    paddingVertical: 15,
    paddingHorizontal: 5,
  },
  tabLabel: {
    fontFamily: AppFonts.OverpassRegular,
    fontSize: 13,
    color: "#9C4900CC",
    textAlign: "center",
    includeFontPadding: false,
  },
  activeTabLabel: {
    fontFamily: AppFonts.OverpassBold,
    color: "#8F4300",
  },
  indicator: {
    position: "absolute",
    bottom: 0,
    height: 3,
    backgroundColor: "#8F4300",
    borderTopLeftRadius: 2,
    borderTopRightRadius: 2,
  },
  contentContainer: {
    flex: 1,
    backgroundColor: AppColors.white,
  },
});
